module.exports = __webpack_public_path__ + "static/media/shuffle.0018fc59.svg";